import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { DataItemForm } from '../DataItemForm'
import { Button } from '@/Atomic/Molecules/Button'
import DropdownMenu from '@/Atomic/Organisms/DropdownMenu'
import { Drawer, DrawerBody, DrawerHeader } from '@/Atomic/Templates/Drawer'
import { useDataItemFormHandler } from '@/utils/CRUD/hooks/useDataItemFormHandler'
import { getPisaSalesDeepLink } from '@/utils/getPisaSalesDeepLink'

import './DataItemDrawer.scss'

interface DataItemInvoiceDrawerProps {
  dataItem: DataItem
  isOpen: boolean
  close: () => void
  openDrawerId?: (id?: string) => void
  nextId?: string
  previousId?: string
}

export const DataItemInvoiceDrawer: React.FC<DataItemInvoiceDrawerProps> = ({
  dataItem,
  isOpen,
  close,
  openDrawerId,
  nextId,
  previousId,
}) => {
  const { t } = useTranslation()

  const { methods, onFormSubmit, isEditing } = useDataItemFormHandler(dataItem)

  const pisaSalesLink = getPisaSalesDeepLink(dataItem)

  return (
    <Drawer isOpen={isOpen} close={close} direction="right">
      <DrawerHeader>
        <div className="header item">
          <Button
            variant="icon"
            icon="cross"
            tooltip={t('tooltip.close')}
            onClick={close}
          />
          <Button
            variant="icon"
            icon="chevron-up"
            tooltip={t('tooltip.previous')}
            onClick={openDrawerId ? () => openDrawerId(previousId) : undefined}
            disabled={!previousId}
            hidden={!openDrawerId}
          />
          <Button
            variant="icon"
            icon="chevron-down"
            tooltip={t('tooltip.next')}
            onClick={openDrawerId ? () => openDrawerId(nextId) : undefined}
            disabled={!nextId}
            hidden={!openDrawerId}
          />
        </div>
        <div className="header item">
          {pisaSalesLink && (
            <DropdownMenu
              buttonClassName="borderless button"
              menuItems={[
                {
                  icon: 'link-external',
                  label: t('common.openIn', { application: 'Classic CRM' }),
                  type: 'default',
                  onClick: () => window.open(pisaSalesLink, '_blank'),
                },
              ]}
            />
          )}
        </div>
      </DrawerHeader>
      <DrawerBody>
        <DataItemForm
          dataItem={dataItem}
          methods={methods}
          onFormSubmit={onFormSubmit}
          isEditing={isEditing}
        />
      </DrawerBody>
    </Drawer>
  )
}
